export const ID_FLOWS = {
  PERSONAL_INFO: 'personal information',
  DOCUMENT_ID: 'document',
  DOCUMENT_ID_APP_CARD: 'document app',
  CONTACT_CARD: 'contacts',
  CONTACT_CARD_LOCKIN: 'contacts lockin',
  CONTACT_CARD_LOCKIN_PROSPECT: 'contacts lockin prospect',
  CONFIRM_IDENDITY: 'verify id',
  CONFIRM_IDENDITY_APP: 'verify id app',
  OTP: 'otp',
  PORTABILITY_LINE: 'portability line',
  PORTABILITY_LINE_APP: 'Portability line app',
  PORTABILITY_INFORMATIONS: 'portability informations',
  PORTABILITY_INTERNET: 'portability internet',
  OPERATORS_INFORMATIONS: 'operators informations',
  PORTABILITY_MIGRATIONS: 'Migration Codes',
  INVOICE: 'Invoice',
  UPFRONT_SELECTION: 'Upfront selection',
  PAYMENT_METHOD: 'Payment method',
  PAYMENT_METHOD_WITHOUT_RECURRING: 'Payment method without recurring',
  RECURRENT_PAYMENT_CARD: 'Recurrent payment card',
  PORTABILITY: 'Portability',
  PORTABILITY_NUMBER: 'Portability Number',
  PORTABILITY_NUMBER_PORTABILITY_REQUIRED: 'Portability Number portability required',
  DELIVERY_ADDRESS: 'Delivery',
  PORTABILITY_SIM_SERIAL: 'Portability Sim Serial',
  PORTABILITY_OTP: 'Portability Otp',
  PORTABILITY_DATA: 'Portability Data',
  TERMS_AND_CONDITIONS: 'Terms and Conditions',
  CONSENTS: 'Consents',
  UPFRONT_PAYMENT: 'Upfront payment',
  VOUCHER: 'Voucher',
  ADDON_CARD: 'Addon',
};

export const enum CHECKOUT_STEP_KEYS {
  ADDON_CARD = 'AddonCard',
  CONFIRM_IDENTITY_APP_CARD = 'ConfirmIdentityAppCard',
  CONFIRM_IDENTITY_CARD = 'ConfirmIdentityCard',
  CONSENT_CARD = 'ConsentCard',
  CONTACT_CARD = 'ContactCard',
  CONTACT_LOCK_IN_CARD = 'ContactLockInCard',
  CONTACT_LOCK_IN_PROSPECT_CARD = 'ContactLockInProspectCard',
  DOCUMENT_ID_CARD = 'DocumentIdCard',
  INVOICE_CARD = 'InvoiceCard',
  LOADING_CARD = 'LoadingCard',
  NAME_FISCAL_CODE_CARD = 'NameFiscalCodeCard',
  OTP_CARD = 'OtpCard',
  PAYMENT_METHOD_WITHOUT_RECURRING_CARD = 'PaymentMethodWithoutRecurringCard',
  PORTABILITY_CARD = 'PortabilityCard',
  PORTABILITY_INFO_CARD = 'PortabilityInfoCard',
  PORTABILITY_INTERNET_CARD = 'PortabilityInternetCard',
  PORTABILITY_LINE_APP_CARD = 'PortabilityLineAppCard',
  PORTABILITY_LINE_CARD = 'PortabilityLineCard',
  PORTABILITY_MIGRATION_CARD = 'PortabilityMigrationCard',
  PORTABILITY_NUMBER_CARD = 'PortabilityNumberCard',
  PORTABILITY_INFORMATIONS_CARD = 'PortabilityInformationsCard',
  RECURRENT_PAYMENT_CARD = 'RecurrentPaymentCard',
  TERMS_AND_CONDITIONS_CARD = 'TermsAndConditionsCard',
  UPFRONT_PAYMENT_CARD = 'UpfrontPaymentCard',
  UPFRONT_SELECTION_CARD = 'UpfrontSelectionCard',
  VOUCHER_CARD = 'VoucherCard',
  DELIVERY_ADDRESS_CARD = 'DeliveryCard',
}
export const CHECKOUT_STEP_CONFIG = [
  { key: CHECKOUT_STEP_KEYS.ADDON_CARD },
  { key: CHECKOUT_STEP_KEYS.CONFIRM_IDENTITY_APP_CARD },
  { key: CHECKOUT_STEP_KEYS.CONFIRM_IDENTITY_CARD },
  { key: CHECKOUT_STEP_KEYS.CONSENT_CARD },
  { key: CHECKOUT_STEP_KEYS.CONTACT_CARD },
  { key: CHECKOUT_STEP_KEYS.CONTACT_LOCK_IN_CARD },
  { key: CHECKOUT_STEP_KEYS.CONTACT_LOCK_IN_PROSPECT_CARD },
  { key: CHECKOUT_STEP_KEYS.DOCUMENT_ID_CARD },
  { key: CHECKOUT_STEP_KEYS.INVOICE_CARD },
  { key: CHECKOUT_STEP_KEYS.LOADING_CARD },
  { key: CHECKOUT_STEP_KEYS.NAME_FISCAL_CODE_CARD },
  { key: CHECKOUT_STEP_KEYS.OTP_CARD },
  { key: CHECKOUT_STEP_KEYS.PAYMENT_METHOD_WITHOUT_RECURRING_CARD },
  { key: CHECKOUT_STEP_KEYS.PORTABILITY_CARD },
  { key: CHECKOUT_STEP_KEYS.PORTABILITY_INFO_CARD },
  { key: CHECKOUT_STEP_KEYS.PORTABILITY_INTERNET_CARD },
  { key: CHECKOUT_STEP_KEYS.PORTABILITY_LINE_APP_CARD },
  { key: CHECKOUT_STEP_KEYS.PORTABILITY_LINE_CARD },
  { key: CHECKOUT_STEP_KEYS.PORTABILITY_MIGRATION_CARD },
  { key: CHECKOUT_STEP_KEYS.PORTABILITY_NUMBER_CARD },
  { key: CHECKOUT_STEP_KEYS.PORTABILITY_INFORMATIONS_CARD },
  { key: CHECKOUT_STEP_KEYS.RECURRENT_PAYMENT_CARD },
  { key: CHECKOUT_STEP_KEYS.TERMS_AND_CONDITIONS_CARD },
  { key: CHECKOUT_STEP_KEYS.UPFRONT_PAYMENT_CARD },
  { key: CHECKOUT_STEP_KEYS.UPFRONT_SELECTION_CARD },
  { key: CHECKOUT_STEP_KEYS.VOUCHER_CARD },
  { key: CHECKOUT_STEP_KEYS.DELIVERY_ADDRESS_CARD },
];

export const DEFAULT_CURRENT_STEP_KEY = ID_FLOWS.PERSONAL_INFO;

